var ShopifyAPI = ShopifyAPI || {};
ShopifyAPI.Cart =
    (function () {
        return {
            /**
             * @param {Number} variantId Variant ID of the variant to be added
             * @param {Number} quantity Amount of the variant to be added
             * 
             * @return {Object} Object with an 'items' array of added products
             */
            add: function (variantId, quantity) {
                return new Promise((resolve, reject) => {
                    if (isNaN(quantity) || quantity <= 0) {
                        reject(new Error('Invalid quantity'))
                    }

                    if (isNaN(variantId)) {
                        reject(new Error('Invalid variant ID'))
                    }

                    let formData = {
                        'items': [{
                            id: variantId,
                            quantity: quantity
                        }]
                    };

                    fetch('/cart/add.js', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify(formData)
                    }).then(response => response.json().then(data => {
                        if (response.status === 200) {
                            resolve(data);
                        } else {
                            reject(response.status);
                        }
                    })).catch(error => {
                        reject(error)
                    });
                });
            },
            /**
             * Get the cart as JSON object
             * 
             * @return {Object} Object representing the cart
             */
            get: function () {
                return new Promise((resolve, reject) => {
                    fetch('/cart.js')
                        .then(response => response.json().then(data => {
                            if (response.status === 200) {
                                resolve(data);
                            } else {
                                reject(response.status);
                            }
                        })).catch(error => {
                            reject(error);
                        });
                });
            },
            /**
             * Updates the quantity of a variant in the cart
             * 
             * @param {Number} variantId Variant ID of the variant to be added
             * @param {Number} quantity Amount of the variant to be added
             * 
             * @return {Object} Object with a list of added items
             * @throws {Number} HTTP response code
             */
            update: function (variantId, quantity) {
                return new Promise((resolve, reject) => {
                    if (isNaN(quantity) || quantity < 0) {
                        reject(new Error('Invalid quantity'))
                    }
    
                    if (isNaN(variantId)) {
                        reject(new Error('Invalid variant ID'))
                    }
                    
                    fetch('/cart/update.js', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({ 'updates': { [variantId]: quantity } })
                    }).then(response => response.json().then(data => {
                        if (response.status === 200) {
                            resolve(data);
                        } else {
                            reject(response.status);
                        }
                    })).catch(error => {
                        reject(error);
                    });
                });
            },
            /**
             * Queries the checkout URL for the current cart
             * 
             * @return {String} Checkout URL
             */
            checkout: function () {
                return new Promise((resolve, reject) => {
                    const formData = new FormData();
                    formData.append('checkout', '');

                    fetch('/cart', {
                        method: 'POST',
                        body: 'formData'
                    }).then(response => {
                        resolve(response.url)
                    }).catch(error => {
                        reject(error);
                    });
                });
            }
        }
    }());